import React from "react";

import { cn } from "./cn";

type Variant = "default" | "outline";

const VARIANT_CLASSES: Record<Variant, string> = {
  default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
  outline: "border-border bg-background text-foreground hover:bg-muted",
};

export interface CoButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

// Ported from the design repo's shadcn button (default + outline variants
// only — the two the onboarding flow uses).
export function CoButton({ variant = "default", className, type = "button", ...props }: CoButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        "inline-flex h-8 shrink-0 select-none items-center justify-center gap-1.5 whitespace-nowrap rounded-lg border px-2.5 text-sm font-medium outline-none transition-all focus-visible:ring-2 focus-visible:ring-ring/50 active:translate-y-px disabled:pointer-events-none disabled:opacity-50",
        VARIANT_CLASSES[variant],
        className
      )}
      {...props}
    />
  );
}
